export interface VehicleGridLoadParams {
  skip?: number
  take?: number
  sort?: string
  filter?: string
}

export interface VehicleGridLoadResult<T = any> {
  data: T[]
  totalCount: number
}

export function buildVehicleGridLoadParams(loadOptions: any): VehicleGridLoadParams {
  const params: VehicleGridLoadParams = {
    skip: loadOptions.skip || 0,
    take: loadOptions.take || 25
  }

  if (loadOptions.sort) {
    params.sort = JSON.stringify(loadOptions.sort)
  }

  if (loadOptions.filter) {
    params.filter = JSON.stringify(loadOptions.filter)
  }

  return params
}

export function normalizeVehicleGridResponse<T = any>(payload: any): VehicleGridLoadResult<T> {
  return {
    data: payload?.data || [],
    totalCount: payload?.totalCount || 0
  }
}
